import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { CookieManager, SessionLifecycleClient } from "@repo/auth-sdk";

CookieManager.configure({
  isDevelopment: import.meta.env.DEV,
});

SessionLifecycleClient.configure({
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL ||
    import.meta.env.VITE_API_URL ||
    "http://localhost:8000",
  clientClass: "auth_web",
});

createRoot(document.getElementById("root")!).render(<App />);
